import { Box, Snackbar, Typography } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as React from "react";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faCircleCheck } from "@fortawesome/sharp-regular-svg-icons";
import { pxToRem } from "../../platform-style";

library.add(faCircleCheck);

interface SuccessSnackBarProps {
  open: boolean;
  message: string;
  onClose: () => void;
  ariaLabel?: string;
}

const SuccessSnackbar = ({ open, message, onClose, ariaLabel }: SuccessSnackBarProps) => {
  if (!message.endsWith(".")) {
    message = message + ".";
  }

  return (
    <Snackbar
      aria-label={ariaLabel}
      open={open}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      key={"bottom" + "center"}
      sx={{
        mb: pxToRem(55),
        backgroundColor: "header.main",
        color: "header.contrastText",
        minWidth: "200px",
        minHeight: "40px",
        borderRadius: 1,
        px: 2,
      }}
      autoHideDuration={5000}
      onClose={onClose}
    >
      <Box sx={{ minWidth: "200px" }}>
        <Box component={"span"} sx={{ mr: 2 }}>
          <FontAwesomeIcon icon={faCircleCheck} data-testid="action-success-icon" />
        </Box>
        <Box component={"span"}>
          <Typography variant={"detailsBarText"}>{message}</Typography>
        </Box>
      </Box>
    </Snackbar>
  );
};

export { SuccessSnackbar as Snackbar };
